import { Component } from "react";

import { ButtonLink } from "../shared/Button";

export default class NotFound extends Component {
  render() {
    const { breakpoint } = this.props;

    const isMobile = breakpoint === "mobile";

    return (
      <div className="h-full w-full flex flex-col flex-1 min-h-0 justify-center items-center relative overflow-y-auto">
        <div className="flex flex-col min-[800px]:flex-row flex-none w-full">
          <div
            className={`flex-1 min-h-0 flex flex-col items-center justify-center md:mr-10 ${
              isMobile ? "items-center" : "items-end"
            }`}
          >
            <span className="icon-emptyState u-notFound"></span>
          </div>
          <div className="mt-10 md:ml-10 md:mt-0 flex flex-col items-center justify-center flex-1 min-h-0">
            <div className="w-full text-center md:max-w-[400px] md:text-left">
              <p className="text-[42px] font-light text-gray-800 leading-none">
                Error 404
              </p>
              <p className="mt-5 text-gray-410 text-base leading-[1.4]">
                Oops, we couldn't find the page you were looking for
              </p>
              <div className="mt-5">
                <ButtonLink to="/" kind="primary-purple" size="large">
                  Take me home
                </ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
